import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { useSelector } from 'react-redux';

import {
  WebcamNotDetected,
  WebcamNotDetectedMoreItems,
  ToggleMore,
} from './Proctor.style';
import IMAGES from '../../constants/Images';
import { popUpClick, popUpView } from '../../utils/trackingUtil';
import { POPUP_NAME } from '../../constants/Constants';

export default function WebcamNotDetectedModal({
  isOpen,
  verbose = 'webcam',
  title = 'Webcam Not Detected',
}) {
  const [showModal, setShowModal] = useState(isOpen);
  const { test_type_verbose, productTypeSmall } = useSelector(
    state => state.test
  );
  const [toggleMore, setToggleMore] = useState(false);

  useEffect(() => {
    if (showModal) {
      popUpView({
        payload: {
          popUpTitle: POPUP_NAME.webcamNotDetected,
          popUpAction: 'Webcam not detected info',
        },
      });
    }
  }, [showModal]);

  const handleProceedToTest = () => {
    setShowModal(false);
    popUpClick({
      payload: {
        popUpTitle: POPUP_NAME.webcamNotDetected,
        popUpAction: 'Webcam not detected info',
        label: 'proceed to test',
      },
    });
  };

  const handleToggleMore = () => {
    setToggleMore(!toggleMore);
  };

  return (
    <>
      <Modal backdrop="static" centered size="lg" isOpen={showModal}>
        <ModalBody>
          <WebcamNotDetected
            src={IMAGES.WEBCAM_NOT_FOUND}
            className="d-block mx-auto"
          />
          <div className="d-flex justify-content-center">
            <h3>{title}</h3>
          </div>
          <p>
            {/* TODO: Use backtick */}
            This {test_type_verbose} requires access to your {verbose}. Please
            check the {verbose} and click on the &apos;Proceed to{' '}
            {productTypeSmall}&apos; button. Interfering with {verbose}{' '}
            functioning can affect your candidature.&nbsp;
            <ToggleMore
              className="text-primary cursor-pointer "
              onClick={handleToggleMore}
            >
              {toggleMore ? 'Show less' : 'Show more'}
            </ToggleMore>
          </p>
          {toggleMore && (
            <WebcamNotDetectedMoreItems>
              - Webcam permission disabled <br />
              - Another application could be using the webcam <br />
              - Browser is not able to detect the webcam <br />
            </WebcamNotDetectedMoreItems>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <button
            type="button"
            onClick={handleProceedToTest}
            className="btn btn-primary"
          >
            proceed to {productTypeSmall}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}
